import { RecordStatus } from '../types/menu/enums.types';
import { PermissionLevel } from '../types/public/enum.types';
import { UserRoleType } from '../types/user-roles/user-roles.types';
import { appList, apps, featuresV2, modulesV2, permissionList, permissions } from './rolesAndPermission';
import { userPermissionContent } from './userPermissionContent';

export type PermissionArrayType = {
  roleKey: `${UserRoleType}`;
  userId: string | null;
  permissionId: (typeof permissionList)[number]['id'];
  appId: (typeof appList)[number]['id'];
  moduleId: number | null;
  featureId?: number | null;
  featureKey?: string;
  key: string;
  isGranted: boolean;
  isApprovalNeeded: boolean;
  permissionLevel: `${PermissionLevel}`;
  type: 'Role' | 'User';
  status: `${RecordStatus}`;
  createdBy: 'System';
}[];

const userPermissionsListMom: PermissionArrayType = [
  // Dishwasher Shift Scheduler
  // Shift Scheduler Module
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 11,
    featureId: null,
    key: userPermissionContent.module.shift_schedule,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  // Shift Scheduler Feature Permissions for Dishwasher
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 11,
    featureId: 35,
    key: userPermissionContent.feature.employee_shift_assign_to_another,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 11,
    featureId: 119,
    key: userPermissionContent.feature.bid_open_shifts_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 11,
    featureId: 31,
    key: userPermissionContent.feature.employee_shift_ownshift,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 11,
    featureId: 34,
    key: userPermissionContent.feature.release_shifts_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // Shift Pool Permissions for Dishwasher
  //    Module Permission

  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 12,
    featureId: null,
    key: userPermissionContent.module.shift_pool,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // Shift Pool Permissions for Dishwasher
  //    Feature Permissions

  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 11,
    featureId: 34,
    key: userPermissionContent.feature.shift_pool.release_manager_approval_required,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  // Pool
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 12,
    featureId: 36,
    key: userPermissionContent.feature.shift_pool.pool_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.mom.id,
    moduleId: 12,
    featureId: 36,
    key: userPermissionContent.feature.shift_pool.pool_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // Module: Task Manager; Role: dish-washer;
  //    Module Permission
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 35,
    featureId: null,
    key: userPermissionContent.module.task_manager,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  //   Feature Permissions

  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 35,
    featureId: 122,
    key: userPermissionContent.feature.tasks_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.mom.id,
    moduleId: 35,
    featureId: 122,
    key: userPermissionContent.feature.tasks_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.mom.id,
    moduleId: 35,
    featureId: 86,
    key: userPermissionContent.feature.can_be_assigned_a_task_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // Module: Lost & Found; Role: dish-washer;
  // Module Permission
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 39,
    featureId: null,
    key: userPermissionContent.module.lost_and_found,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  //   Feature Permissions
  // Lost items
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Create.id,
    appId: apps.mom.id,
    moduleId: 39,
    featureId: 125,
    key: userPermissionContent.feature.lost_items_create,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 39,
    featureId: 125,
    key: userPermissionContent.feature.lost_items_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.mom.id,
    moduleId: 39,
    featureId: 125,
    key: userPermissionContent.feature.lost_items_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Edit.id,
    appId: apps.mom.id,
    moduleId: 39,
    featureId: 125,
    key: userPermissionContent.feature.lost_items_edit,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Delete.id,
    appId: apps.mom.id,
    moduleId: 39,
    featureId: 125,
    key: userPermissionContent.feature.lost_items_delete,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  //   Found Items
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Create.id,
    appId: apps.mom.id,
    moduleId: 39,
    featureId: 126,
    key: userPermissionContent.feature.found_items_create,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Delete.id,
    appId: apps.mom.id,
    moduleId: 39,
    featureId: 126,
    key: userPermissionContent.feature.found_items_delete,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Edit.id,
    appId: apps.mom.id,
    moduleId: 39,
    featureId: 126,
    key: userPermissionContent.feature.found_items_edit,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.mom.id,
    moduleId: 39,
    featureId: 126,
    key: userPermissionContent.feature.found_items_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 39,
    featureId: 126,
    key: userPermissionContent.feature.found_items_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // Module: Pay Management; Role: dish-washer;
  // Module Permission
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 42,
    featureId: null,
    key: userPermissionContent.module.pay_management,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  //   Feature Permissions
  // Own Paystubs
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 42,
    featureId: 132,
    key: userPermissionContent.feature.pay_management.own_pay_stubs,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // Module: Dashboard; Role: dish-washer;
  // Module Permission
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 38,
    featureId: null,
    key: userPermissionContent.module.dashboard,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  //   Feature Permissions
  // your week
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 38,
    featureId: 11,
    key: userPermissionContent.feature.your_week_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.mom.id,
    moduleId: 38,
    featureId: 11,
    key: userPermissionContent.feature.your_week_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // Module: Timecards; Role: dish-washer;
  // Module Permission
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 3,
    featureId: null,
    key: userPermissionContent.module.timecards,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  //   Feature Permissions
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 3,
    featureId: 12,
    key: userPermissionContent.feature.timecard.view_own_timecards_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.mom.id,
    moduleId: 3,
    featureId: 12,
    key: userPermissionContent.feature.timecard.view_own_timecards_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // Module: Employee Availability; Role: dish-washer;
  // Module Permission
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 4,
    featureId: null,
    key: userPermissionContent.module.employee_availability,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  //   Feature Permissions
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 4,
    featureId: 15,
    key: userPermissionContent.feature.availability_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Create.id,
    appId: apps.mom.id,
    moduleId: 4,
    featureId: 15,
    key: userPermissionContent.feature.availability_create,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.mom.id,
    moduleId: 4,
    featureId: 15,
    key: userPermissionContent.feature.availability_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Edit.id,
    appId: apps.mom.id,
    moduleId: 4,
    featureId: 15,
    key: userPermissionContent.feature.availability_edit,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Delete.id,
    appId: apps.mom.id,
    moduleId: 4,
    featureId: 15,
    key: userPermissionContent.feature.availability_delete,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // Module: Employee Time Off; Role: dish-washer;
  // Module Permission
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 5,
    featureId: null,
    key: userPermissionContent.module.employee_time_off,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  //   Feature Permissions
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 5,
    featureId: 16,
    key: userPermissionContent.feature.time_off_request_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Create.id,
    appId: apps.mom.id,
    moduleId: 5,
    featureId: 16,
    key: userPermissionContent.feature.time_off_request_create,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.mom.id,
    moduleId: 5,
    featureId: 16,
    key: userPermissionContent.feature.time_off_request_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // Module: My Account; Role: dish-washer;
  // Module Permission
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 2,
    featureId: null,
    key: userPermissionContent.module.my_account,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  //   Feature Permissions
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.mom.id,
    moduleId: 2,
    featureId: 110,
    key: userPermissionContent.feature.my_account_list,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 2,
    featureId: 110,
    key: userPermissionContent.feature.my_account_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Create.id,
    appId: apps.mom.id,
    moduleId: 2,
    featureId: 110,
    key: userPermissionContent.feature.my_account_create,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Delete.id,
    appId: apps.mom.id,
    moduleId: 2,
    featureId: 110,
    key: userPermissionContent.feature.my_account_delete,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Edit.id,
    appId: apps.mom.id,
    moduleId: 2,
    featureId: 110,
    key: userPermissionContent.feature.my_account_update,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // Module: Pay Management; Role: server;
  // Feature Permission
  {
    roleKey: 'server',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 42,
    featureId: 132,
    key: userPermissionContent.feature.pay_management.own_pay_stubs,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // Module: Pay Management; Role: cook;
  // Feature Permission
  {
    roleKey: 'cook',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 42,
    featureId: 132,
    key: userPermissionContent.feature.pay_management.own_pay_stubs,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // Module: Pay Management; Role: janitorial;
  // Feature Permission
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 42,
    featureId: 132,
    key: userPermissionContent.feature.pay_management.own_pay_stubs,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // Module: Timecards; Role: janitorial;
  // Module Permission
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 3,
    featureId: null,
    key: userPermissionContent.module.timecards,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  //   Feature Permissions
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 3,
    featureId: 12,
    key: userPermissionContent.feature.timecard.view_own_timecards_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.mom.id,
    moduleId: 3,
    featureId: 12,
    key: userPermissionContent.feature.timecard.view_own_timecards_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // Module: Dashboard; Role: janitorial;
  // Module Permission
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 38,
    featureId: null,
    key: userPermissionContent.module.dashboard,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  //   Feature Permissions
  // your week
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 38,
    featureId: 11,
    key: userPermissionContent.feature.your_week_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.mom.id,
    moduleId: 38,
    featureId: 11,
    key: userPermissionContent.feature.your_week_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // Module: Employee Availability; Role: janitorial;
  // Module Permission
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 4,
    featureId: null,
    key: userPermissionContent.module.employee_availability,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  //   Feature Permissions
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 4,
    featureId: 15,
    key: userPermissionContent.feature.availability_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Create.id,
    appId: apps.mom.id,
    moduleId: 4,
    featureId: 15,
    key: userPermissionContent.feature.availability_create,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.mom.id,
    moduleId: 4,
    featureId: 15,
    key: userPermissionContent.feature.availability_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Edit.id,
    appId: apps.mom.id,
    moduleId: 4,
    featureId: 15,
    key: userPermissionContent.feature.availability_edit,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Delete.id,
    appId: apps.mom.id,
    moduleId: 4,
    featureId: 15,
    key: userPermissionContent.feature.availability_delete,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // Module: Employee Time Off; Role: janitorial;
  // Module Permission
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 5,
    featureId: null,
    key: userPermissionContent.module.employee_time_off,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  //   Feature Permissions
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 5,
    featureId: 16,
    key: userPermissionContent.feature.time_off_request_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Create.id,
    appId: apps.mom.id,
    moduleId: 5,
    featureId: 16,
    key: userPermissionContent.feature.time_off_request_create,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.mom.id,
    moduleId: 5,
    featureId: 16,
    key: userPermissionContent.feature.time_off_request_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // Module: Shift Scheduler; Role: janitorial;
  // Module Permission
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 11,
    featureId: null,
    key: userPermissionContent.module.shift_schedule,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  // Shift Scheduler Feature Permissions for Dishwasher
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 11,
    featureId: 35,
    key: userPermissionContent.feature.employee_shift_assign_to_another,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 11,
    featureId: 119,
    key: userPermissionContent.feature.bid_open_shifts_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 11,
    featureId: 31,
    key: userPermissionContent.feature.employee_shift_ownshift,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 11,
    featureId: 34,
    key: userPermissionContent.feature.release_shifts_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // Module: Shift Pool; Role: janitorial;
  // Module Permission
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 12,
    featureId: null,
    key: userPermissionContent.module.shift_pool,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // Shift Pool Permissions for Dishwasher
  //    Feature Permissions

  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 11,
    featureId: 34,
    key: userPermissionContent.feature.shift_pool.release_manager_approval_required,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  // Pool
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 12,
    featureId: 36,
    key: userPermissionContent.feature.shift_pool.pool_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.mom.id,
    moduleId: 12,
    featureId: 36,
    key: userPermissionContent.feature.shift_pool.pool_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // Module: Task Manager; Role: janitorial;
  //    Module Permission
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 35,
    featureId: null,
    key: userPermissionContent.module.task_manager,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  //   Feature Permissions

  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 35,
    featureId: 122,
    key: userPermissionContent.feature.tasks_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.mom.id,
    moduleId: 35,
    featureId: 122,
    key: userPermissionContent.feature.tasks_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.mom.id,
    moduleId: 35,
    featureId: 86,
    key: userPermissionContent.feature.can_be_assigned_a_task_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // Module: Lost & Found; Role: janitorial;
  // Module Permission
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 39,
    featureId: null,
    key: userPermissionContent.module.lost_and_found,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  //   Feature Permissions
  // Lost items
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Create.id,
    appId: apps.mom.id,
    moduleId: 39,
    featureId: 125,
    key: userPermissionContent.feature.lost_items_create,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 39,
    featureId: 125,
    key: userPermissionContent.feature.lost_items_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.mom.id,
    moduleId: 39,
    featureId: 125,
    key: userPermissionContent.feature.lost_items_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Edit.id,
    appId: apps.mom.id,
    moduleId: 39,
    featureId: 125,
    key: userPermissionContent.feature.lost_items_edit,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Delete.id,
    appId: apps.mom.id,
    moduleId: 39,
    featureId: 125,
    key: userPermissionContent.feature.lost_items_delete,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  //   Found Items
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Create.id,
    appId: apps.mom.id,
    moduleId: 39,
    featureId: 126,
    key: userPermissionContent.feature.found_items_create,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Delete.id,
    appId: apps.mom.id,
    moduleId: 39,
    featureId: 126,
    key: userPermissionContent.feature.found_items_delete,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Edit.id,
    appId: apps.mom.id,
    moduleId: 39,
    featureId: 126,
    key: userPermissionContent.feature.found_items_edit,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.mom.id,
    moduleId: 39,
    featureId: 126,
    key: userPermissionContent.feature.found_items_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 39,
    featureId: 126,
    key: userPermissionContent.feature.found_items_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // Module: Dashboard; Role: busser;
  // Module Permission
  {
    roleKey: 'busser',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 38,
    featureId: null,
    key: userPermissionContent.module.dashboard,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  //   Feature Permissions
  // your week
  {
    roleKey: 'busser',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 38,
    featureId: 11,
    key: userPermissionContent.feature.your_week_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'busser',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.mom.id,
    moduleId: 38,
    featureId: 11,
    key: userPermissionContent.feature.your_week_read,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // Module: Cook Prep List; Role: gm;
  // Module Permission

  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions['Visible'].id, // view
    appId: apps['mom'].id, // mom
    moduleId: modulesV2['inventory-cook-prep-list'].id,
    featureId: null,
    key: userPermissionContent.module.cook_prep_list,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  // Feature Permission
  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions['Visible'].id,
    appId: apps['mom'].id,
    moduleId: modulesV2['inventory-cook-prep-list'].id,
    featureId: featuresV2['inventory-cook-prep-list'].id,
    key: userPermissionContent.feature.cook_prep_list,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // Module: Pay Management; Role: gm;
  // Module Permission

  // Own pay stubs
  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions['Visible'].id,
    appId: apps['mom'].id,
    moduleId: 42,
    featureId: 132,
    key: userPermissionContent.feature.pay_management.own_pay_stubs,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // Module: Inventory Variance; Role: Cook;
  // Module Permission
  {
    roleKey: 'cook',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['inventory-variance'].id, // Inventory Variance
    featureId: null,
    key: userPermissionContent.module.inventory_variance,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'cook',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['inventory-variance'].id, // Inventory Variance
    featureId: featuresV2['inventory-variance'].id,
    key: userPermissionContent.feature.inventory_variance,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // Module: Wastage Logs; Role: Cook;
  // Module Permission

  {
    roleKey: 'cook',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['inventory-wastage-logs'].id, // Inventory Wastage Logs
    featureId: null,
    key: userPermissionContent.module.wastage_logs,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'cook',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['inventory-wastage-logs'].id, // Inventory Wastage Logs
    featureId: featuresV2['inventory-wastage-logs'].id,
    key: userPermissionContent.feature.wastage_logs,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
];

const newChefPermissionsMom: PermissionArrayType = [
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 2,
    featureId: null,
    key: 'my-account-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 3,
    featureId: null,
    key: 'timecards-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 4,
    featureId: null,
    key: 'employee-availability-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 5,
    featureId: null,
    key: 'employee-time-off-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: null,
    key: 'shift-scheduler-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 12,
    featureId: null,
    key: 'shift-pool-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 35,
    featureId: null,
    key: 'task-manager-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 38,
    featureId: null,
    key: 'dashboard-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: null,
    key: 'lost-&-found-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 42,
    featureId: null,
    key: 'pay-management-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 3,
    featureId: 12,
    key: 'view-own-timecards-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 3,
    featureId: 12,
    key: 'view-own-timecards-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 5,
    featureId: 16,
    key: 'time-off-request-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 5,
    featureId: 16,
    key: 'time-off-request-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 5,
    featureId: 16,
    key: 'time-off-request-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 5,
    featureId: 16,
    key: 'time-off-request-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 5,
    featureId: 16,
    key: 'time-off-request-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 31,
    key: 'own-shifts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 33,
    key: 'release-other-employees-shift-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 34,
    key: 'release-shifts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 35,
    key: 'assign-to-another-employee-button-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 118,
    key: 'release-manager-approval-required-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 12,
    featureId: 36,
    key: 'pool-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 12,
    featureId: 37,
    key: 'pool-view-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 35,
    featureId: 86,
    key: 'can-be-assigned-a-task-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 35,
    featureId: 122,
    key: 'tasks-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 35,
    featureId: 122,
    key: 'tasks-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 38,
    featureId: 11,
    key: 'your-week-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 38,
    featureId: 11,
    key: 'your-week-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: 127,
    key: 'mark-as-retrieved-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 42,
    featureId: 132,
    key: 'view-own-paystubs-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: null,
    featureId: null,
    key: 'pos-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'App',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: null,
    key: 'clock-in-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: 133,
    key: 'clock-in-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: null,
    featureId: null,
    key: 'mpos-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'App',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 22,
    featureId: null,
    key: 'login-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 22,
    featureId: 77,
    key: 'login-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: 70,
    key: 'employee-attendance-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // Module: Pay Management; Role: chef;
  // Feature Permission
  {
    roleKey: 'chef',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 42,
    featureId: 132,
    key: userPermissionContent.feature.pay_management.own_pay_stubs,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
];

export const newPermissionsMom = [...userPermissionsListMom, ...newChefPermissionsMom];
